import $ from 'jquery';

class Fragment {

  constructor ( element, methods ) {
    this._element = element;
    this._methods = methods;
    this._url = $( element ).data( 'fragment' );

    this._overlay = $( '<div class="loading-overlay"></div>');
    $( window ).on( 'resize scroll', e => {
      this.setOverlayPosition();
    } );
  }

  block () {
    this._element.trigger( 'block.fragment' );
    this._overlay.prependTo( document.body );
    this.setOverlayPosition();
    this._element
      .addClass( 'is-blocked' )
      .trigger( 'blocked.fragment' );
  }

  unblock () {
    this._overlay.detach();
    this._element
      .removeClass( 'is-blocked' )
      .trigger( 'unblocked.fragment' );
  }

  load () {
    this._element.trigger( 'load.fragment' );
    $.ajax( this._url )
      .done( ( data ) => {
        if ( data.fragment ) {
          $( this._element ).html( data.fragment );
          this._element.trigger( 'loaded.fragment' );
          setTimeout( () => {
            this.unblock();
          }, 100 );
        } else {
          this._element.trigger( 'blank.fragment' );
          this.unblock();
        }
      } )
      .fail( () => {
        this._element.trigger( 'error.fragment' );
        this.unblock();
      } );
  }

  post (args) {
    console.log(this._url)
    this._element.trigger( 'load.fragment' );
    $.ajax( this._url, {
        method: 'POST',
        data: args,
      } )
      .done( ( data ) => {
        if ( data.fragment ) {
          $( this._element ).html( data.fragment );
          this._element.trigger( 'loaded.fragment' );
          setTimeout( () => {
            this.unblock();
          }, 100 );
        } else {
          this._element.trigger( 'blank.fragment' );
          this.unblock();
        }
      } )
      .fail( () => {
        this._element.trigger( 'error.fragment' );
        this.unblock();
      } );
  }

  setOverlayPosition() {
    if ( ! $.contains( document.body, this._overlay[0] ) )
      return;

    const display = this._element.is( ':visible' ) ? 'block' : 'none';
    let zIndex = this.getParentIndex();
    zIndex += 10;
    this._overlay.css( {
      display: display,
      zIndex: zIndex,
      top: this._element.offset().top,
      left: this._element.offset().left,
      width: this._element.outerWidth(),
      height: this._element.outerHeight()
    } );
  }

  getParentIndex() {
    let zIndex;
    this._element.parents().each( function () {
      const temp = $( this ).css( 'z-index' );
      zIndex = temp != 'auto' ? parseInt( temp ) : zIndex;
    } );
    return zIndex;
  }

  static _jQueryInterface ( method, options ) {
    return this.each( function () {
      let element = $( this );
      let data = element.data( '_fragment' );

      if ( ! data ) {
        data = new Fragment( element );
        $( this ).data( '_fragment', data );
      }

      if ( typeof method === 'string' ) {
        if ( typeof data[method] === 'undefined' ) {
          throw new TypeError( `No method named "${method}"` );
        }
        data[ method ](options);
      }
    } );
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn.fragment             = Fragment._jQueryInterface;
$.fn.fragment.Constructor = Fragment;

export default Fragment;